module.exports = __webpack_public_path__ + "img/WMSone.237114ec.png";